import styled from 'styled-components';
import Button from '../../REUSEABLE/Button/Button';
import { Link } from 'react-router-dom';

export const Linkk = styled(Link)`
  width: fit-content;
`;

export const Buttonn = styled(Button)``;
